(function ($, document, window) {
    'use strict';

    $(document).ready(function () {
        init();
        $('body').on('cms.ready', init); // re-init after cms is ready
    });

    function init() {
        var $schoolsignup = $('.school-signup__form');


        if ($schoolsignup.length > 0) { // if form exists

            // Add click handler for adding more siblings used in form school-signup
            $('a.add_sibling', $schoolsignup).off('click', addSibling).on('click', addSibling);

            // add repeatable functionality
            $('.school-signup__guardians')
                .add('.school-signup__adults')
                .add('.school-signup__siblings')
                .add('.school-signup__siblings-waiting')
                .each(bindRepeater);

            // validation for checkbox
            $schoolsignup.on('submit', validateForm);
            $('.js-require-checkbox, .js-require-radio').on('change', validateForm);

            // method call to validate input fields type = text
            handleValidation();
        }
    }

    function bindRepeater(i, elm) {
        var $parent = $(elm);
        var $template = $parent.find('template');

        $parent.find('.button').on('click', function (elm, i) {
            $template.parent().append($template.html());
        });
    }

    /**
     * Method to validate checkbox in school-signup-email form
     */
    function validateForm(event) {
        var $permissionAccept = $(event.currentTarget);
        var $agreeCheckBox = $permissionAccept.find('input');
        var $warningLabel = $permissionAccept.find('li');

        if (event.type === 'submit') {
            // run for all on page
            $permissionAccept = $('.js-require-checkbox, .js-require-radio');

            // check for guardians is is required min one
            if ($('.school-signup__guardians') && $('.school-signup__guardians input').length === 0) {
                // no guardians yet
                $('.school-signup__guardians a.button').click();
                $('.school-signup__guardians input[name="guardians[].name"]').focus();
                return;
            }
        }

        $permissionAccept.each(function(i, elm) {
            if ($agreeCheckBox.prop('type') === 'checkbox' || $agreeCheckBox.prop('type') === 'radio') {
                console.log($agreeCheckBox.prop('type'), $agreeCheckBox.is(':checked'), $agreeCheckBox.val());

                if ($agreeCheckBox.is(':checked')) {
                    $warningLabel.remove();
                    return;
                }

                // else: wait for jQuery validation to finish
                setTimeout(function () {
                    $permissionAccept.find('li').remove();
                    $warningLabel = $('<li><label class="error">Dette felt er påkrævet.</label></li>');
                    $permissionAccept.append($warningLabel);
                }, 1);
            }
        });
    }

    /**
     * Method to handle validation for both school-signup & school-signup-email
     */
    function handleValidation() {
        var $schoolsignup = $('.school-signup__form');
        // Handle extra validation
        var $guardians = $('.school-signup__guardians', $schoolsignup);
        // (input name ends with "name")
        var $guardians_name = $('input[name$="name"]', $guardians);

        $guardians_name.on('change', function (evt) {
            var $this = $(this),
                setRequired = $this.val().length > 0, // Fields are required if value is not empty
                $labels = $this.parent().siblings('.set-required'), // Need a parent pointer
                $inputs = $('input', $labels);
            if (setRequired) {
                $inputs.attr('required', 'required');
                $inputs.addClass('error');
            } else {
                $inputs.removeAttr('required');
                $inputs.removeClass('error');
            }
        });
        $guardians_name.trigger('change');
    }

    /**
     * Method to add more siblings  used in  "school-signup" page
     * @param evt
     */
    function addSibling(evt) {
        evt.preventDefault();
        var $this = $(this),
            $fieldset = $this.parents('fieldset');

        // Fetch template inside fieldset
        var $template = $('.school-signup__siblings--template', $fieldset).clone();
        // Reset input fields
        $('input', $template).val('');
        // Remove template class
        $template.removeClass('school-signup__siblings--template');
        // Insert before the button
        $template.insertBefore($this.parent());
    }


})(jQuery, document, window);